const merge = require('lodash/merge')

const appConfig = {
  all: {
    env: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    apiUrl: process.env.REACT_APP_API_URL,
    mediaUrl: process.env.REACT_APP_MEDIA_URL,
    generalInfo: process.env.REACT_APP_GENERAL_INFO_URL,
    courseUrl: process.env.REACT_APP_API_COURSE_LINK,
    basePath: process.env.REACT_APP_BASE_PATH,
    gtmId: process.env.REACT_APP_GTM_ID,
    xIbmClientId: process.env.REACT_APP_X_IBM_CLIENT_ID,
  },
  development: {
  },
  production: {
  },
}
const config = merge(appConfig.all, appConfig[appConfig.all.env])

export default config
